import { PREFIX, URIType } from "../uri";

export enum PhysicalIdType {
  Unknown,
  Legacy,
  BankId,
  USSocialSecurityNo,
}

export class PhysicalIdURI {
  type: URIType.PhysicalId = URIType.PhysicalId;
  idType: PhysicalIdType;
  id: string;

  static parse(uri: string) {
    const [, type, idType, ...parts] = uri.split(":").map(decodeURIComponent);
    if (type !== "id") {
      return null;
    }

    if (idType === "legacy") {
      return new PhysicalIdURI(PhysicalIdType.Legacy, parts[0]);
    }

    if (idType === "ssn") {
      const [region, id] = parts;
      if (region === "se") {
        return new PhysicalIdURI(PhysicalIdType.BankId, id);
      }
      if (region === "us") {
        return new PhysicalIdURI(PhysicalIdType.USSocialSecurityNo, id);
      }
    }

    return null;
  }

  static fromString(text: string) {
    const uri = PhysicalIdURI.parse(text);
    if (!uri) {
      throw new Error("Not PhysicalIdURI");
    }
    return uri;
  }

  constructor(idType: PhysicalIdType, id: string) {
    this.idType = idType;
    this.id = id;
  }

  toString() {
    const parts = [PREFIX, "id"];

    if (this.idType === PhysicalIdType.Legacy) {
      parts.push("legacy", this.id);
    } else if (this.idType === PhysicalIdType.BankId) {
      parts.push("ssn", "se", this.id);
    } else if (this.idType === PhysicalIdType.USSocialSecurityNo) {
      parts.push("ssn", "us", this.id);
    }

    return parts.map(encodeURIComponent).join(":");
  }
}
